import React from 'react';
import IntegrationLogs from '../../IntegrationLogs';

/**
 * Renders the integration audit log in its existing collapsible panel.
 *
 * @param {object} props
 * @param {string} props.companyId
 * @param {string} props.integrationId
 */
export const IntegrationLogsSection = ({ companyId, integrationId }) => {
    return (
        <IntegrationLogs companyId={companyId} integrationId={integrationId} />
    );
};
